import React from 'react';
import {
    Box,
    IconButton,
    Tooltip,
    Typography,
    useTheme,
} from '@material-ui/core';
import { X } from 'react-feather';
import { useTranslation } from 'react-i18next';

export const Header = ({ onClose }: { onClose: () => void }) => {
    const theme = useTheme();
    const { t } = useTranslation();

    return (
        <Box
            p={2}
            borderBottom={`1px solid ${theme.palette.divider}`}
            bgcolor={theme.palette.background.paper}
            display="flex"
            alignItems="center"
        >
            <Tooltip title="Cerrar">
                <IconButton color="primary" onClick={onClose}>
                    <X />
                </IconButton>
            </Tooltip>

            <Typography variant="h5" color="textPrimary">
                {t('Chat.ChatNotes')}
            </Typography>
        </Box>
    );
};
